// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3613":"0615d590","7689":"0615d590"}[chunkId] + ".chunk.css";
};